<template lang="pug">
    v-dialog(v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")    
        v-card
            v-app-bar(
                :color='colorTheme'
                class="navFixed"
                height="48px;"
            )
                v-toolbar-title(style="font-size: 18px; font-weight: 700; color: white" class="ml-3") 
                  span(v-if="dataType == 'icon_approve'") Approval
                  span(v-else-if="dataType == 'icon_reject'") Rejection 
                  span(v-else) Withdraw
                  span  Sign Icon Preview
                v-spacer
                v-toolbar-items
                v-btn(dark text  @click.native="dialog = false")
                    v-icon(title="Close") cancel
                    | &nbsp;Close
            v-list(three-line subheader class="print-bg padTop60")
                div(id="1" style="height: 100%; min-height: 100vh;")
                    .page(size="Auto" style="height:700px;" class="pagebreak")

                        strong Approval list for 
                        i(class="fw-300") Daftar persetujuan untuk
                        p(style="font-size: 14px;") No. 12121212

                        div(class="view-width detail-wrap" style="position:relative;font-size:14px;height:auto;")
                        
                            table(class="view-width" border="1" style="margin:10px 0;border:1px solid black;border-collapse: collapse;text-align:center;z-index:100;")
                                tbody
                                    tr
                                        td(colspan="3" align="center" style="") 
                                            b Approved by
                                            i(class="fw-300")  Disetujui Oleh 
                                    tr(style="background: #F3F4F6;")
                                        td(width="36%") 
                                            b Name & Position 
                                            br
                                            i(class="fw-300")  Nama  & Jabatan
                                        td(width="32%") 
                                            b Comment
                                            br
                                            i(class="fw-300")  Komentar
                                        td(width="32%")
                                            b Digital Signature
                                            br
                                            i(class="fw-300")  Tanda Tangan Digital

                                    tr(height="80px")
                                        td(width="40%" class="px-3")
                                            b Budi Hermawan / Manager
                                        td Lorem ipsum
                                        td(class="approved") 
                                            img(
                                                v-if="dataType == 'icon_approve'" 
                                                :src="item.url" 
                                                height="34px"
                                            )
                                            img(
                                                v-else-if="dataType == 'icon_reject'" 
                                                :src="item.url" 
                                                height="34px"
                                            )
                                            img(
                                                v-else-if="dataType == 'icon_withdraw'" 
                                                :src="item.url" 
                                                height="34px"
                                            )
                                            div {{ getTanggal() }}

                            div(style="text-align: center; margin-top: 1rem; margin-bottom: 1rem;")
                                div(style="font-size:14px;font-weight:bold;color:red; text-align:center") QR code to validate the correctness of the information on the digital signature in this document. 
                                i(class="fw-300") Kode QR untuk memvalidasi kebenaran informasi pada tanda tangan digital dalam dokumen ini.
                            p(style="text-align: center;")
                                img(src="../assets/qr-code.png" style="vertical-align:middle;width:150px;")
          
</template>

<script>
export default {
  name: "PreviewLogo",
  props: {
    item: Object,
    dataType: String,
    color: String
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    colorTheme: function() {
      return this.color ? this.color : '#D42A2A';
    },
  },
  methods: {
    getTanggal: function() {
      let tanggal = new Date();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      const month = tanggal.toLocaleString('default', { month: 'short' });
      let hour = tanggal.getHours();
      let minutes = tanggal.getMinutes();
      return date+' '+month+' '+tanggal.getFullYear()+' '+hour+':'+minutes;
    },
  },
};
</script>

<style scoped>
.print-bg {
  background: rgb(204,204,204) !important;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 13px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.width-150px {
  width: 150px;
}
.top-align {
  vertical-align:top;
}

.tgLbl {
  position: relative;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #fff;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
  .page[size="Auto"] {
    width: auto;
    margin:0 auto;
    display:block;
    text-align:initial;
  }
  table { page-break-inside:auto; }
  tr    { page-break-inside:avoid; page-break-after:auto; }
  .pagebreak { page-break-before: always; } /* page-break-after works, as well */
  p { page-break-after: auto; page-break-before: auto; page-break-inside: avoid; }
  .image {padding: 5%; page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
  .table {page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:0px;
  left:0px;
  text-align: right;
  width: 100%;
}
.imgWaterMark {
  width: 10%;
  position:absolute;
  top:0px;
  right:10px;
}

/* ========== CUSTOM CSS =========== */
.fw-300{
  font-weight:300;
}

ul.list-creator{
  list-style-type: none;
  padding-left: 0;
}

ul.list-creator li{
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #E1E1E1;
}


ul.list-creator li:nth-child(n+2){
  padding-top: 0.5rem;
}

hr.custom-hr{
  border: 0; border-top: 1.4px solid #1E1E1E;
  margin: 1em 0; padding: 0;
}

.content-memo{
  text-align: justify;
  margin-bottom: 1.4rem;
}

.content-memo strong{
  font-size: 16px;
}

.content-memo i{
  font-size: 16px;
}

.content-memo div{
  font-size: 14px
}

.imgWaterMark-fully-approved {
  width: 7%;
  position: absolute;
  top: -50px;
  right: 10px;
}

.imgWaterMark-on-approval{
  width: 8%;
  position: absolute;
  top: -50px;
  right: 10px;
}

.text-rotate{
  position: absolute; 
  right: 0;
  font-size: 60px;
  font-weight: 600;
  transform: rotate(90deg);
}

.im-withdraw{
  color: rgba(237, 27, 36, 0.1);
  top: 210px;
  right: -120px;
}

.im-rejected{
  color: rgba(237, 27, 36, 0.1);
  top: 190px;
  right: -110px;
}

.im-fully-approved{
  color: rgba(17, 182, 54, 0.1);
  top: 160px;
  right: -140px;
}

.im-on-approval{
  color: rgba(250, 255, 0, 0.1);
  top: 170px;
  right: -125px;
}

.im-draft{
  color: rgba(79, 79, 79, 0.1);
  top: 150px;
  right: -120px;
}

.v-toolbar__content{
  height: 48px;
}

div.divFooter {
  display: none;
}

.imgWaterMarkPrint{
  display: none;
}

.im-draft-print{
  display: none;
}

.imgWaterMark-fully-approved-print {
  display: none;
}

.imgWaterMark-on-approval-print{
  display: none;
}

.im-withdraw-print{
  display: none;
}

.im-rejected-print{
  display: none;
}

.im-fully-approved-print{
  display: none;
}

.im-on-approval-print{
  display: none;
}

.imgWaterMark-rejected-print{
  display: none;
}

.imgWaterMarkPrint-withdraw-print{
  display: none;
}

.height-80px{
  height: 80px;
  width: auto;
}

td.custom-td {
    vertical-align: middle;
}

td.custom-td img {
    vertical-align: middle;
    display: inline-block;
    margin-right: 0.6rem;
}

td.custom-td .inline-block{
  vertical-align: middle;
  display: inline-block;
}

td.custom-td .tagline{
  text-align: left;
}

.logo-title{
    font-size: 22px;
    font-weight: 600;
    color: #121212;
    margin-bottom: -0.4rem;
    text-align: left;
}
</style>

<style>
.ck-content .image>img {
    display: block;
    margin: 0 auto;
    max-width: 80% !important;
}
</style>
